import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
}

const variants = {
  primary: "bg-earnings text-white hover:bg-earnings-dark shadow-lg shadow-earnings/30",
  secondary: "bg-white/10 text-white hover:bg-white/20 border border-white/20",
  danger: "bg-event text-white hover:bg-event-dark",
  ghost: "text-white/70 hover:text-white hover:bg-white/10",
};

const sizes = {
  sm: "px-3 py-1.5 text-sm font-semibold rounded-lg",
  md: "px-5 py-2.5 text-base font-bold rounded-xl",
  lg: "px-7 py-3.5 text-lg font-bold rounded-2xl",
};

export default function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}: Props) {
  return (
    <button
      className={`transition-all duration-150 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed font-display ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
